/**
 * Created by wuyanbin on 2019/5/18
 */
/**
 * 组件使用场景：争议处理
 * 组件使用 -> API:dispatch.DealDispute.show(id) 展开model => id为逻辑必需值
 * API使用 ->
 * API:import { showDealDispute } from '@/shared/utils';
 * showDealDispute(id) 展开model => id为逻辑必需值
 *
 * */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Form, Input, Select, Radio } from 'antd';
import { Provider, connect } from '@souche-f2e/muji';
import store, { dispatch, getState } from '@@/store';
import { CHECK_MONEY, CHECK_VALUE_RANGE } from '@/shared/reqexp';
// import { Span } from '@sentry/hub';
// import { consoleSandbox } from '@sentry/utils';
const mapStateToProps = (rootState) => ({
    dealDispute: rootState.dealDispute,
    _state: rootState.disputeManage,
});
class DealDisputeComponent extends Component {
    constructor(props) {
        super(props);
        /**
         * 计算新的合手价格
         */
        this.countNewJointPrice = () => {
            const props = this.props;
            const { jointPrice, reduceServiceFee, reduceCommissionFee, reduceCarPrice } = getState().dealDispute;
            const newJointPrice = Number(jointPrice) - Number(reduceServiceFee) - Number(reduceCommissionFee) - Number(reduceCarPrice);
            if (newJointPrice >= 0) {
                props.form.setFieldsValue({
                    newJointPrice,
                });
            }
            else {
                props.form.setFields({
                    newJointPrice: {
                        value: 0,
                        errors: [new Error('合手价不足抵扣或格式不正确')],
                    },
                });
            }
        };
        this.onChange = (e) => {
            this.setState({
                value: e.target.value,
            });
            this.resetForm();
        };
        this.state = {
            value: 0,
            count: 0,
        };
        this.ok = this.ok.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.cancel = this.cancel.bind(this);
        this.afterClose = this.afterClose.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.handleChangeText = this.handleChangeText.bind(this);
        this.disputeTypeChange = this.disputeTypeChange.bind(this);
    }
    cancel() {
        dispatch.dealDispute.hide();
        this.resetForm();
    }
    afterClose() {
        dispatch.dealDispute.resetState();
        this.resetForm();
        this.setState({
            count: 0,
            value: 0,
        });
    }
    ok() {
        const props = this.props;
        dispatch.dealDispute.confirmDispute(props.form);
    }
    handleOk() {
        const props = this.props;
        dispatch.dealDispute.dealTransDetail(props.form);
    }
    resetForm() {
        const props = this.props;
        props.form.resetFields();
    }
    disputeTypeChange(val, option) {
        dispatch.dealDispute.changeOpenType(val);
        this.resetForm();
    }
    /**
     * 计算新合手价格
     */
    handlePriceChange(e, type) {
        dispatch.dealDispute.SET_STATE({
            [type]: e.target.value,
        });
        this.countNewJointPrice();
    }
    /**
     * 分割标题
     */
    _renderDividerTitle(title) {
        return (<span style={{ borderLeft: '2px solid #9c8f8f', paddingLeft: '5px', fontWeight: 500 }}>
        {title}
      </span>);
    }
    /**
     * 违约扣款
     * 买方违约 卖方违约
     * @param props
     * @param currentSelDealType
     * @returns {any}
     * @private
     * 0: {keyName: "0", value: "买方违约"}
     * 1: {keyName: "1", value: "卖方违约"}
     */
    _renderDefaultPay(props, currentSelDealType) {
        const { getFieldDecorator } = props.form;
        const { buyerDepositBalance, sellerDepositBalance } = props.dealDispute;
        const maxCanUseDepositBalance = currentSelDealType === '0' ? buyerDepositBalance : sellerDepositBalance;
        return (<div>
        {this._renderDividerTitle('违约扣款')}
        <Form.Item label="违约保证金(元)">
          {getFieldDecorator('defaultPayment', {
            initialValue: 2000,
            rules: [
                // {
                //   validator: (rule: any, value: any, callback: any) => {
                //     if (!value || value.isAfter(moment())) {
                //       callback();
                //     }
                //     else {
                //       callback('竞拍结束时间需晚于当前时间');
                //     }
                //   },
                // },
                { validator: CHECK_VALUE_RANGE(maxCanUseDepositBalance) },
                // { validator: CHECK_MONEY(false, 'hundred') },
                { validator: CHECK_MONEY(false, 'hundred', 9999999, true) },
            ],
        })(<Input placeholder="请输入违约扣款金额"/>)}
          <span style={{ color: '#FF571A' }}>最大可用{maxCanUseDepositBalance}元</span>
        </Form.Item>
      </div>);
    }
    /**
     * 买家费用减免
     * @private
     */
    _renderReduceBuyerFee(props) {
        const { getFieldDecorator } = props.form;
        const { IsBuyerPay, jointPrice } = props.dealDispute;
        return (<div>
        {this._renderDividerTitle('买家费用减免')}
        {!IsBuyerPay && <Form.Item label="减免服务费(元)">
            {getFieldDecorator('reduceServiceFee', {
            rules: [{
                    required: false,
                    validator: CHECK_MONEY(),
                }],
        })(<Input placeholder="请输入减免服务费金额" onChange={(val) => {
            this.handlePriceChange(val, 'reduceServiceFee');
        }}/>)}
          </Form.Item>}
        {!IsBuyerPay && <Form.Item label="减免佣金(元)">
            {getFieldDecorator('reduceCommissionFee', {
            rules: [{ validator: CHECK_MONEY() }],
        })(<Input placeholder="请输入违约扣款金额" onChange={(val) => {
            this.handlePriceChange(val, 'reduceCommissionFee');
        }}/>)}
          </Form.Item>}
        <Form.Item label="减免车款(元)">
          {getFieldDecorator('reduceCarPrice', {
            rules: [{ validator: CHECK_MONEY() }],
        })(<Input placeholder="请输入违约扣款金额" onChange={(val) => {
            this.handlePriceChange(val, 'reduceCarPrice');
        }}/>)}
        </Form.Item>
        {!IsBuyerPay && <Form.Item label="新合手价(元)">
            {getFieldDecorator('newJointPrice', {
            initialValue: jointPrice,
            rules: [{ validator: CHECK_MONEY() }],
        })(<Input placeholder="请输入违约扣款金额" disabled/>)}
          </Form.Item>}
      </div>);
    }
    /**
     0: {keyName: "0", value: "买方违约"}
     1: {keyName: "1", value: "卖方违约"}
     2: {keyName: "2", value: "继续交易"}
     3: {keyName: "3", value: "流拍"}
     */
    _renderDealDetail(currentSelDealType, props) {
        switch (currentSelDealType) {
            case '1':
            case '0':
                return this._renderDefaultPay(props, currentSelDealType);
            case '2':
                return this._renderReduceBuyerFee(props);
            case '3':
                return null;
            default:
                return null;
        }
    }
    disputesResolution() {
        const props = this.props;
        const { getFieldDecorator } = props.form;
        const { visible, disputeDealType, currentSelDealType, } = props.dealDispute;
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
        };
        return (<Modal centered title="争议处理" okText="确认" onOk={this.ok} cancelText="取消" onCancel={this.cancel} visible={visible} afterClose={this.afterClose}>
        <Form {...formItemLayout}>
          <Form.Item label="处理类型">
            {getFieldDecorator('disputeDealType', {
            rules: [
                {
                    required: true,
                    message: '请选择争议处理类型',
                },
            ],
        })(<Select placeholder="请选择争议处理类型" notFoundContent="暂无数据" onChange={this.disputeTypeChange}>
                {disputeDealType.map((v, i) => (<Select.Option value={v.keyName} key={`open-${i}`}>{v.value}</Select.Option>))}
              </Select>)}
          </Form.Item>
          
          {this._renderDealDetail(currentSelDealType, props)}
          <Form.Item colon={false} label="处理结果备注">
            {getFieldDecorator('disputeReason', {
            rules: [
                {
                    required: true,
                    message: '请填写处理结果备注',
                },
                {
                    max: 50,
                    message: '限50字',
                },
            ],
        })(<Input.TextArea placeholder="请填写处理结果备注" autoSize={{
            minRows: 4,
            maxRows: 4,
        }}/>)}
          </Form.Item>
        </Form>
      </Modal>);
    }
    handleChangeText(e) {
        const count = e.target.value.length;
        this.setState({
            count,
        });
    }
    daYuDisputesResolution() {
        const props = this.props;
        const { getFieldDecorator } = props.form;
        const { sellerPriceYuanUnit } = this.props._state;
        const typeNum = Number(sellerPriceYuanUnit);
        const { visible, } = props.dealDispute;
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 17 },
        };
        return (<Modal centered title="争议处理" okText="确认" onOk={this.handleOk} cancelText="取消" onCancel={this.cancel} visible={visible} afterClose={this.afterClose}>
        <Form {...formItemLayout} labelAlign="right">
          <Form.Item label="争议处理">
            {getFieldDecorator('disputeResult', {
            initialValue: 0, rules: [
                {
                    required: true,
                }
            ]
        })(<Radio.Group onChange={this.onChange}>
                <Radio value={0}>赔付</Radio>
                <Radio value={1}>无赔付</Radio>
                <Radio value={2}>取消争议</Radio>
              </Radio.Group>)}
          </Form.Item>
          
          
          
          {this.state.value === 0 ?
            <Form.Item colon={false} label="赔付金额">
                {getFieldDecorator('compensationPrice', {
                rules: [
                    {
                        required: true,
                        message: '金额不能为空',
                    },
                    // { validator: CHECK_VALUE_RANGE(typeNum) },
                    { validator: CHECK_MONEY(false, 'hundred', typeNum, true) },
                ],
            })(<Input placeholder="请输入" suffix={<span style={{
                color: '#999999',
            }}>
                        元
                    </span>}/>)}
              </Form.Item>
            : ''}
          <Form.Item colon={false} label="处理说明">
            {getFieldDecorator('disputeRemark', {
            rules: [
                {
                    max: 100,
                    message: '限100字',
                },
            ],
        })(<Input.TextArea placeholder="请输入" autoSize={{
            minRows: 6,
            maxRows: 8,
        }} maxLength={100} onChange={this.handleChangeText}/>)}
            <span style={{ position: 'absolute', bottom: -13, right: 7, resize: 'none', color: '#999999' }}>
              {this.state.count}/100
              </span>
          </Form.Item>
        </Form>
      </Modal>);
    }
    render() {
        const { actionType, orderTag } = this.props._state;
        return (<div>
        {(actionType === 10 && orderTag === 1) ?
            this.daYuDisputesResolution()
            :
                this.disputesResolution()}
      </div>);
    }
}
DealDisputeComponent.defaultProps = {};
const DealDispute = connect(mapStateToProps, null, null, { forwardRef: true })(Form.create({})(DealDisputeComponent));
export default DealDispute;
/**
 * API
 * */
let componentRef = '';
const createDealDispute = () => {
    const div = document.createElement('div');
    div.className = 'souche-deal-dispute';
    document.body.appendChild(div);
    // @ts-ignore
    const component = (
    // @ts-ignore
    <Provider store={store}>
      {React.createElement(DealDispute, {
        ref: (ref) => {
            componentRef = ref;
        },
    })}
    </Provider>);
    ReactDOM.render(component, div);
};
export function showDealDispute({ id, jointPrice, IsBuyerPay, orderStatusCode, callback }) {
    if (!componentRef) {
        createDealDispute();
    }
    dispatch.dealDispute.showDealDisputeModal({ id, jointPrice, IsBuyerPay, callback }).then(() => {
        if (Number(orderStatusCode) === 20) {
            dispatch.dealDispute.getDisputeDealType({ typeId: 112 });
        }
        else {
            dispatch.dealDispute.getDisputeDealType({ typeId: 20 });
        }
        dispatch.dealDispute.getUserDepositBalance({ disputeCode: id });
    });
}
